export default __webpack_public_path__ + "static/media/pear.68ae6382.png";